var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          !_vm.sslDetailsLoaded
            ? [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "4"
                    }
                  },
                  [
                    _c("gg-loading", {
                      attrs: {
                        loading: true,
                        type: "card"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "4"
                    }
                  },
                  [
                    _c("gg-loading", {
                      attrs: {
                        loading: true,
                        type: "card"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      sm: "4"
                    }
                  },
                  [
                    _c("gg-loading", {
                      attrs: {
                        loading: true,
                        type: "card"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12"
                    }
                  },
                  [
                    _c("gg-loading", {
                      attrs: {
                        loading: true,
                        type: "table"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm.certificateIssued
        ? _c(
            "v-row",
            [
              _vm.isAlphaSSL
                ? [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          sm: "4"
                        }
                      },
                      [_c("site-seal")],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12",
                          sm: "4"
                        }
                      },
                      [_c("warranty")],
                      1
                    )
                  ]
                : _vm._e(),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "4"
                  }
                },
                [_c("download-certificate")],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("installation-status", {
                    attrs: {
                      id: _vm.id
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm.ssl
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("ssl-auto-installer", {
                    attrs: {
                      id: _vm.id
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }